import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path d="M13 5v2H6v10h7v2H4V5h9zm3 2l5 5-5 5-1.5-1.5L17 13H9v-2h8l-2.5-2.5L16 7z" fill={color} fillRule="nonzero" />
  </svg>
);
